import { render } from "./Logo.vue?vue&type=template&id=43ee6720"
const script = {}
script.render = render

export default script